export default __webpack_public_path__ + "static/media/WeLoveMoviesRoutes.50fcf28f.png";